import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { AdjustmentBreakdownAdditionalStructure } from './AdjustmentBreakdownAdditionalStructure.tsx';

export const AdjustmentBreakdownAdditionalStructureShed = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <AdjustmentBreakdownAdditionalStructure
    {...props}
    breakdownCategory="shed"
    title="Shed"
    id="isDepreciatedCostAdditionalImprovementsShedInExport"
    summary={props}
  />
);
